import api from "./api";

const LS_KEY = "uvdj_progress";

const readLocal = () => {
  try {
    return JSON.parse(localStorage.getItem(LS_KEY)) || { chapters: {}, last: null };
  } catch {
    return { chapters: {}, last: null };
  }
};

export const loadProgress = async (user) => {
  if (user) {
    try {
      const { data } = await api.get("/progress");
      return data;
    } catch {
      return readLocal();
    }
  }
  return readLocal();
};

export const saveProgress = (user, chapterId, percent, last = false) => {
  const local = readLocal();
  const cur = local.chapters[String(chapterId)] || { percent: 0, read: false };
  cur.percent = Math.max(cur.percent, Math.min(100, Math.round(percent)));
  cur.read = cur.percent >= 95;
  local.chapters[String(chapterId)] = cur;
  if (last) local.last = chapterId;
  localStorage.setItem(LS_KEY, JSON.stringify(local));
  if (user) {
    api.post("/progress", { chapter_id: chapterId, percent: cur.percent, last }).catch(() => {});
  }
};

const BM_KEY = "uvdj_bookmarks";

export const loadBookmarks = async (user, chapterId) => {
  if (user) {
    try {
      const { data } = await api.get(`/bookmarks?chapter_id=${chapterId}`);
      return data;
    } catch { return []; }
  }
  try {
    const all = JSON.parse(localStorage.getItem(BM_KEY)) || {};
    return all[String(chapterId)] || [];
  } catch { return []; }
};

export const saveBookmark = async (user, chapterId, percent, note = "") => {
  const bm = { bm_id: `bm_${Date.now()}`, chapter_id: chapterId, percent: Math.round(percent), note, created_at: new Date().toISOString() };
  if (user) {
    try {
      const { data } = await api.post("/bookmarks", { chapter_id: chapterId, percent: bm.percent, note });
      return data;
    } catch { return bm; }
  }
  const all = JSON.parse(localStorage.getItem(BM_KEY) || "{}");
  all[String(chapterId)] = [...(all[String(chapterId)] || []), bm].slice(-10);
  localStorage.setItem(BM_KEY, JSON.stringify(all));
  return bm;
};

export const deleteBookmark = async (user, chapterId, bmId) => {
  if (user) {
    try { await api.delete(`/bookmarks/${bmId}`); } catch { /* noop */ }
    return;
  }
  const all = JSON.parse(localStorage.getItem(BM_KEY) || "{}");
  all[String(chapterId)] = (all[String(chapterId)] || []).filter((b) => b.bm_id !== bmId);
  localStorage.setItem(BM_KEY, JSON.stringify(all));
};
